import React from 'react';

import PropTypes from 'prop-types';
import get from 'lodash.get';
import Banner from './Banner';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { useAppContext } from '../../common/contexts/AppContext';

const BMInterventionBanner = ({ studentUid, needsSupport }) => {
    const bannerContext = useBannerContext();
    const { classId } = useAppContext();
    const {
        actions: { hideBMInterventionBanner },
    } = bannerContext;
    const isBMInterventionBannerVisible = get(
        bannerContext[classId],
        `${studentUid}.isBMInterventionBannerVisible`,
        true,
    );
    const dismissHandler = () => hideBMInterventionBanner({ classId, studentUid });
    const bannerMessage = needsSupport ? (
        <div>
            This student may need extra support to reach grade level goals by the end of the year.
            If this student will receive mCLASS Intervention, administer the required measures below
            before putting them into a group.
        </div>
    ) : (
        <div>
            If this student will receive enrichment through mCLASS Intervention, administer the
            required measure below before putting them into a group.
        </div>
    );
    return isBMInterventionBannerVisible ? (
        <Banner
            isInformation
            isDismissible
            showIcon={false}
            dismissHandler={dismissHandler}
            className='dashboard-section'
        >
            {bannerMessage}
        </Banner>
    ) : null;
};

BMInterventionBanner.propTypes = {
    studentUid: PropTypes.string.isRequired,
    needsSupport: PropTypes.bool.isRequired,
};

export default BMInterventionBanner;
